import React, { useEffect, useState, useContext } from 'react';
import { useNavigateParams } from '../../../hooks/useNavigateParams';

import { Context } from '../../../context/UserContext';
import Form from './Form';
import styles from '../../form/Form.module.css';

import { getEmpresaScope } from '../../../helpers/sessionEmpresa';
import { resolveEmpresaTabela } from '../../../utils/funcoes';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';

import * as EmpresaAPI from '../../../api/empresa';
import * as SituacaoAPI from '../../../api/situacao';
import CrudsAPI from '../../../api/CRUDs';

import { applyHomologationBoot } from './boot/applyHomologationBoot';
import { getFrontVersionLabel } from '../../../utils/appVersion';
import { getServerVersion } from '../../../utils/serverVersion';

const CreateOrEdit = () => {
    const [dados, setDados] = useState({});
    const [token] = useState(localStorage.getItem('token')) || '';
    const { parametro } = useContext(Context);
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();
    const urlParams = new URLSearchParams(window.location.search);

    // escopo empresa
    const { pessoaId, empresaId, empresaIds } = getEmpresaScope();
    const empresaTabelaId = resolveEmpresaTabela(parametro, empresaId);

    const pathname = '/Homologation';
    const ul = urlParams.get('ul');
    const li = urlParams.get('li');
    const tipo = urlParams.get('tipo');
    const operacaoUUID = urlParams.get('operacao');
    const uuid = urlParams.get('uuid');
    const btnText = urlParams.get('btnText');

    const params = new URLSearchParams({
        ul: ul,
        li: li,
        tipo: tipo,
        operacao: operacaoUUID,
        uuid: uuid,
        btnText: btnText,
    });

    const profile = {
        labelForm: 'Homologação do Sistema',
    };

    const [optionsEmpresa, setEmpresa] = useState([]);
    const [optionsSituacao, setOptionsSituacao] = useState([]);
    // const [optionsSituacaoHomologationPessoa, setSituacaoHomologationPessoa] = useState([]);
    const [optionsSituacaoHomologationItem, setSituacaoHomologationItem] = useState([]);

    const consultaEmpresa = async () => {
        const dados = await EmpresaAPI.empresa(empresaId);
        setEmpresa(dados);
    };

    const consultaSituacao = async (tabela) => {
        try {
            const result = await SituacaoAPI.situacoes(empresaTabelaId);

            if (tabela === 'homologation') {
                const filtrado = result?.filter((item) => item.homologation === true) || [];
                setOptionsSituacao(filtrado);
            }
            if (tabela === 'homologationPessoa') {
                const filtrado = result?.filter((item) => item.homologationPessoa === true) || [];
                //setSituacaoHomologationPessoa(filtrado);
            }
            if (tabela === 'homologationItem') {
                const filtrado = result?.filter((item) => item.homologationItem === true) || [];
                setSituacaoHomologationItem(filtrado);
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if (!token) {
            navigate('/Auth', { replace: true });
        }
    }, [token, navigate]);

    useEffect(() => {
        const carregarBoot = async () => {
            consultaEmpresa();
            consultaSituacao('homologation');
            consultaSituacao('homologationItem');
            consultaSituacao('homologationPessoa');

            if (uuid && uuid !== 'null') {
                CrudsAPI.homologation
                    .consulta(uuid)
                    .then((response) => {
                        setDados(response.data);
                    })
                    .catch((error) => {
                        console.error(error);
                        setFlashMessage(
                            error.response?.data?.message || 'Erro ao consultar registro!',
                            error.response?.data?.type || 'error'
                        );
                    });
            } else {
                const serverInfo = await getServerVersion();

                setDados((prev) =>
                    applyHomologationBoot({
                        prev,
                        empresaId,
                        situacaoId: parametro.situacaoHomologacaoId,
                        versaoFront: getFrontVersionLabel(),
                        versaoBack: serverInfo.versaoBack || '',
                    })
                );
            }
        };

        carregarBoot();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uuid, empresaId]);

    async function managerDados(obj) {
        try {
            let response;

            if (uuid && uuid !== 'null') {
                response = await CrudsAPI.homologation.editar(obj);
            } else {
                response = await CrudsAPI.homologation.cadastrar(obj);
                params.set('btnText', 'Cadastrar');
            }

            setFlashMessage(response.data.message, response.data.type);

            setTimeout(() => {
                navigate(pathname, params);
            }, parametro.msgTempo * 1000);
        } catch (error) {
            console.error(error);
            setFlashMessage(error.response?.data?.message || 'Erro ao salvar registro!', error.response?.data?.type || 'error');
        }
    }

    return (
        <section className={`${styles.form_container} ${styles[parametro.tema]}`}>
            <Form
                token={token}
                dados={dados}
                setDados={setDados}
                handleSubmit={managerDados}
                btnText={btnText}
                caminhoVoltar={pathname}
                parametro={parametro}
                pessoaId={pessoaId}
                empresaId={empresaId}
                empresaIds={empresaIds}
                empresaTabelaId={empresaTabelaId}
                profile={profile}
                setFlashMessage={setFlashMessage}
                navigate={navigate}
                optionsEmpresa={optionsEmpresa}
                optionsSituacao={optionsSituacao}
                optionsSituacaoHomologationItem={optionsSituacaoHomologationItem}
            />
        </section>
    );
};

export default CreateOrEdit;
